@app.controller 'HomeController', (MetadataService, AnalyticsService, $rootScope) ->

  AnalyticsService.track 'Viewed New Homepage'

  # other defaults are good
  MetadataService.set
    canonical: '/'

  this
